/* Exploded-view assembly sequences. Steps are driven by data attributes in snippets/htn-assembly-*.liquid. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP_MS = 2600;

  function list(el, key) {
    return (el.getAttribute(key) || '').split(',').filter(function (v) { return v !== ''; });
  }

  function Seq(fig) {
    this.fig = fig;
    this.items = [].slice.call(fig.querySelectorAll('.asm-steps li'));
    this.last = this.items.length - 1;
    this.n = this.last;
    this.timer = null;
    this.played = false;
    this.build();
  }

  Seq.prototype.build = function () {
    var self = this;
    var ctl = document.createElement('div');
    ctl.className = 'asm-ctl';
    ctl.innerHTML =
      '<button type="button" data-asm-prev>Back</button>' +
      '<button type="button" data-asm-play>Play</button>' +
      '<button type="button" data-asm-next>Next</button>' +
      '<span class="asm-count" aria-live="polite"></span>';
    this.fig.querySelector('.asm-stage').appendChild(ctl);
    this.prev = ctl.querySelector('[data-asm-prev]');
    this.next = ctl.querySelector('[data-asm-next]');
    this.play = ctl.querySelector('[data-asm-play]');
    this.count = ctl.querySelector('.asm-count');
    this.prev.addEventListener('click', function () { self.played = true; self.stop(); self.go(self.n - 1); });
    this.next.addEventListener('click', function () { self.played = true; self.stop(); self.go(self.n + 1); });
    this.play.addEventListener('click', function () { self.timer ? self.stop() : self.start(); });
    this.items.forEach(function (li, i) {
      li.tabIndex = 0;
      li.addEventListener('click', function () { self.played = true; self.stop(); self.go(i); });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.played = true; self.stop(); self.go(i); }
      });
    });
    this.go(0);
  };

  Seq.prototype.go = function (n) {
    n = Math.max(0, Math.min(this.last, n));
    this.n = n;
    var fig = this.fig;
    [].forEach.call(fig.querySelectorAll('[data-x]'), function (el) {
      var v = list(el, 'data-x')[n];
      if (v !== undefined) el.style.transform = 'translateX(' + v + 'px)';
    });
    [].forEach.call(fig.querySelectorAll('[data-r]'), function (el) {
      var v = list(el, 'data-r')[n];
      if (v !== undefined) el.style.transform = 'rotate(' + v + 'deg)';
    });
    [].forEach.call(fig.querySelectorAll('[data-show]'), function (el) {
      el.classList.toggle('is-on', list(el, 'data-show').indexOf(String(n)) > -1);
    });
    [].forEach.call(fig.querySelectorAll('[data-hl]'), function (el) {
      el.classList.toggle('is-hl', list(el, 'data-hl').indexOf(String(n)) > -1);
    });
    this.items.forEach(function (li, i) {
      if (i === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
    if (this.items[n].hasAttribute('data-mk')) fig.setAttribute('data-step-mk', ''); else fig.removeAttribute('data-step-mk');
    this.count.textContent = 'Step ' + (n + 1) + ' / ' + (this.last + 1);
    fig.dispatchEvent(new CustomEvent('asm:step', { detail: { n: n } }));
    this.prev.disabled = n === 0;
    this.next.disabled = n === this.last;
  };

  Seq.prototype.start = function () {
    var self = this;
    this.played = true;
    if (this.n === this.last) this.go(0);
    this.play.textContent = 'Pause';
    this.timer = setInterval(function () {
      if (self.n >= self.last) { self.stop(); return; }
      self.go(self.n + 1);
    }, STEP_MS);
  };

  Seq.prototype.stop = function () {
    clearInterval(this.timer);
    this.timer = null;
    this.play.textContent = this.n === this.last ? 'Replay' : 'Play';
  };

  function init(root) {
    if (root.classList.contains('is-live')) return;
    root.classList.add('is-live');
    var figs = [].slice.call(root.querySelectorAll('.asm-fig'));
    var seqs = figs.map(function (f) { return new Seq(f); });
    // two switches: the brand picker (data-asm-dev) and the riflescope / monocular tabs (data-asm-tab)
    var tabs = root.querySelector('.asm-tabs');
    var devs = root.querySelector('.asm-devs');
    var tabBtns = tabs ? [].slice.call(tabs.querySelectorAll('[data-asm-tab]')) : [];
    var devBtns = devs ? [].slice.call(devs.querySelectorAll('[data-asm-dev]')) : [];
    var cur = { seq: figs[0] && figs[0].getAttribute('data-asm-seq'), dev: figs[0] && figs[0].getAttribute('data-asm-dev') };
    var has = function (seq, dev) {
      return seqs.some(function (s) { return s.fig.getAttribute('data-asm-seq') === seq && s.fig.getAttribute('data-asm-dev') === dev; });
    };
    var show = function (seq, dev, auto) {
      if (!has(seq, dev)) seq = has('clip', dev) ? 'clip' : 'mono';
      cur.seq = seq; cur.dev = dev;
      tabBtns.forEach(function (b) {
        var k = b.getAttribute('data-asm-tab');
        b.setAttribute('aria-pressed', String(k === seq));
        b.disabled = !has(k, dev);
      });
      devBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-asm-dev') === dev)); });
      seqs.forEach(function (s) {
        var on = s.fig.getAttribute('data-asm-seq') === seq && s.fig.getAttribute('data-asm-dev') === dev;
        var was = !s.fig.hidden;
        s.fig.hidden = !on;
        if (!on) { s.stop(); return; }
        if (!was) s.fig.dispatchEvent(new CustomEvent('asm:shown', { bubbles: true }));
        if (auto && !reduce && !s.played) s.start();
      });
    };
    tabBtns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-asm-tab'), cur.dev, true); }); });
    devBtns.forEach(function (b) { b.addEventListener('click', function () { show(cur.seq, b.getAttribute('data-asm-dev'), true); }); });
    if (tabs && tabBtns.length > 1) tabs.hidden = false;
    if (devs && devBtns.length > 1) devs.hidden = false;
    show(cur.seq, cur.dev, false);
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        seqs.forEach(function (s) { if (!s.fig.hidden && !s.played) s.start(); });
      });
    }, { threshold: 0.45 });
    io.observe(root);
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-asm]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
